import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decimal, Money } from "@station/core";
import { useEffect, useState } from "react";
import { Input } from "../components/form.js";
import { cn } from "../lib/cn.js";
import { formatMoneyInput, formatQuantityInput, parseMoneyInput, parseQuantityInput, } from "./parse.js";
/**
 * Odaktayken ham metin düzenlenir; odaktan çıkınca ayrıştırılıp Türkiye biçimine getirilir.
 * Değer dışarıya DİZGE olarak verilir (kuruş ya da ondalık); `number` hiçbir aşamada kullanılmaz.
 */
function NumericTextInput({ value, onValueChange, onParseError, parse, format, suffix, className, onBlur, onFocus, ...props }) {
    const [text, setText] = useState(() => format(value));
    const [focused, setFocused] = useState(false);
    const [invalid, setInvalid] = useState(false);
    useEffect(() => {
        if (!focused)
            setText(format(value));
        // `format` her render'da yeni işlev olabilir; yalnızca değer/odak değişimi anlamlıdır.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, focused]);
    return (_jsxs("div", { className: "relative", children: [_jsx(Input, { ...props, inputMode: "decimal", autoComplete: "off", value: text, "aria-invalid": invalid || props["aria-invalid"], className: cn("tabular text-right", suffix && "pr-10", className), onFocus: (event) => {
                    setFocused(true);
                    event.target.select();
                    onFocus?.(event);
                }, onChange: (event) => {
                    setText(event.target.value);
                    const result = parse(event.target.value);
                    if (result.ok) {
                        setInvalid(false);
                        onParseError?.(null);
                        onValueChange(result.value);
                    }
                }, onBlur: (event) => {
                    setFocused(false);
                    const result = parse(text);
                    setInvalid(!result.ok);
                    onParseError?.(result.ok ? null : result.message);
                    if (result.ok) {
                        onValueChange(result.value);
                        setText(format(result.value));
                    }
                    onBlur?.(event);
                } }), suffix ? (_jsx("span", { className: "pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm text-muted-foreground", "aria-hidden": "true", children: suffix })) : null] }));
}
export function MoneyInput({ allowNegative, ...props }) {
    return (_jsx(NumericTextInput, { ...props, suffix: "\u20BA", placeholder: props.placeholder ?? "0,00", parse: (text) => parseMoneyInput(text, { allowNegative }), format: formatMoneyInput }));
}
export const QUANTITY_UNITS = {
    LITRE: { suffix: "L", scale: 3 },
    KWH: { suffix: "kWh", scale: 3 },
    /** Su ve doğalgaz sayaçları (metreküp). */
    M3: { suffix: "m³", scale: 3 },
    KG: { suffix: "kg", scale: 3 },
    PIECE: { suffix: "adet", scale: 0 },
    MINUTE: { suffix: "dk", scale: 0 },
    /** Tank seviyesi ve su seviyesi (prob ölçümü): numeric(10,2). */
    MM: { suffix: "mm", scale: 2 },
    /** Akaryakıt sıcaklığı: numeric(5,2). NEGATİF olabilir — `allowNegative` verilmelidir. */
    CELSIUS: { suffix: "°C", scale: 2 },
};
export function QuantityInput({ unit, allowNegative, ...props }) {
    const { suffix, scale } = QUANTITY_UNITS[unit];
    return (_jsx(NumericTextInput, { ...props, suffix: suffix, parse: (text) => parseQuantityInput(text, scale, { allowNegative }), format: (value) => formatQuantityInput(value, scale) }));
}
/** Tutarı "1.234,56 ₺" biçiminde, sütunda hizalı (tabular) gösterir. */
export function MoneyText({ value, colorize, className }) {
    if (value === null || value === undefined || value === "")
        return _jsx("span", { className: cn("text-muted-foreground", className), children: "\u2014" });
    const money = Money.fromMinor(value);
    return (_jsx("span", { className: cn("tabular whitespace-nowrap", colorize && money.isNegative() && "text-destructive", className), children: money.formatTr() }));
}
export function QuantityText({ value, unit, className, }) {
    if (value === null || value === undefined || value === "")
        return _jsx("span", { className: cn("text-muted-foreground", className), children: "\u2014" });
    const { suffix, scale } = QUANTITY_UNITS[unit];
    return (_jsxs("span", { className: cn("tabular whitespace-nowrap", className), children: [Decimal.from(value).formatTr(scale), " ", suffix] }));
}
//# sourceMappingURL=numeric-inputs.js.map